import { render, staticRenderFns } from "./BuildingUserManagement.vue?vue&type=template&id=ad4010a4&scoped=true&"
import script from "./BuildingUserManagement.vue?vue&type=script&lang=js&"
export * from "./BuildingUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./BuildingUserManagement.vue?vue&type=style&index=0&id=ad4010a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad4010a4",
  null
  
)

export default component.exports